import { render, staticRenderFns } from "./WizardTabSlot.vue?vue&type=template&id=1cecd7c5&"
import script from "./WizardTabSlot.vue?vue&type=script&lang=js&"
export * from "./WizardTabSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports